$(function() {
    changekTextSize();

    $(document).on('click', '.js-show-all-text', function toggleParagraph() {
        $('.js-paragraph').toggleClass('is-open');
    });
});

function changekTextSize() {
    const p = $('.js-paragraph');

    const clone = $('<div class="keyvisual-description__more js-paragraph"></div>');
    const text = $(p).text();

    $(clone).css({
        position: 'absolute',
        display: 'block',
        width: $(p).width(),
        visibility: 'hidden'
    });

    $(clone).text(text);
    $(p).after(clone);

    if ($(p).height() >= $(clone).height())
        return $(clone).remove();

    const btn = $('<a class="keyvisual-description__link js-show-all-text"></a>');

    $(p).html(`${$(clone).text().substr(0, 320)}... `);

    $(clone).removeAttr('style');

    $(p).append(btn.text('More'));
    $(clone).append(btn.clone().text('Less'));

    $('.js-paragraph').last().removeAttr('style');
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/cut-description.js